export default defineNuxtPlugin((nuxtApp) => {
	window.$nuxt = nuxtApp;
});
